module.exports = __webpack_public_path__ + "static/media/poc-table.2f998eec.png";